<app-reports
  title="WAG Specialty Store Claim Match Report"
  [filtersForm]="filtersForm"
  [reportsUrl]="reportsUrl">

  <ng-template appNewReportOptionsTemplate let-filtersForm="filtersForm">
    <ng-container [formGroup]="filtersForm">

      <app-report-date-range-option
        formControlName="createdDate"
        label="Claim Creation Date" />

    </ng-container>
  </ng-template>

  <ng-template appReportDetailsTemplate let-report="report">

    <app-report-applied-date-range-option
      [options]="report.filters"
      name="createdDate"
      label="Claim Creation Date" />

  </ng-template>

</app-reports>
